import styled from 'styled-components';

import { BodyTextMediumA, BodyTextMediumB } from '@/shared/ui/typography2';

export const HardModalBackdrop = styled.div`
  position: fixed;
  z-index: 2147483647;
  inset: 0;
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  background: #131315;
`;

export const HardModalDialog = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: calc(18px + env(safe-area-inset-top))
    calc(18px + env(safe-area-inset-right))
    calc(18px + env(safe-area-inset-bottom))
    calc(18px + env(safe-area-inset-left));
  outline: none;
`;

export const HardModalMain = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: 18px 0;
`;

export const HardModalTitle = styled(BodyTextMediumA)`
  flex: none;
  color: #fff;
  line-height: 130%;
  text-align: center;
`;

export const HardModalIllustration = styled.img`
  flex: none;
  width: min(256px, 72vw, 34dvh);
  height: min(256px, 72vw, 34dvh);
  margin-top: 12px;
  object-fit: contain;
`;

export const HardModalMessage = styled(BodyTextMediumB)`
  max-width: 360px;
  margin-top: 12px;
  color: #fff;
  line-height: 130%;
  text-align: center;
`;

export const HardModalActions = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
`;

export const HardModalButton = styled.button<{
  $variant: 'danger' | 'secondary';
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-width: 0;
  min-height: 48px;
  padding: 10px 24px;
  border: 0;
  border-radius: 8px;
  background: ${({ $variant }) =>
    $variant === 'danger' ? 'rgba(208, 51, 49, 0.5)' : '#27262b'};
  cursor: pointer;

  &:hover,
  &:active {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid #ff9704;
    outline-offset: 2px;
  }
`;

export const HardModalButtonText = styled(BodyTextMediumB)`
  color: #fff;
  line-height: 130%;
`;
